import React, { useState, useEffect } from 'react';
import logo from '../../assets/logo.png';
import './sidebar.css';

export default function Sidebar() {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [showSidebar, setShowSidebar] = useState(true);

  // Alternar visibilidade manual da sidebar
  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  // Fechar sidebar ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      const sidebar = document.querySelector('.sidebar');
      const menuIcon = document.querySelector('.menu-icon');

      if (sidebar && !sidebar.contains(event.target) && !menuIcon.contains(event.target)) {
        setSidebarOpen(false);
      }
    };

    if (isSidebarOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isSidebarOpen]);

  // Controlar visibilidade da sidebar ao rolar a página
  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      if (window.scrollY > lastScrollY && window.scrollY > 50) {
        setShowSidebar(false); // Esconde a sidebar ao rolar para baixo
      } else {
        setShowSidebar(true); // Mostra a sidebar ao voltar ao topo
      }
      lastScrollY = window.scrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
      <div>
        {/* Ícone do menu visível apenas em telas pequenas */}
        <div className="menu-icon" onClick={toggleSidebar}>
          &#9776; {/* Ícone "hamburger" */}
        </div>

        {/* Sidebar com efeito de desaparecimento ao rolar */}
        <div className={`sidebar ${isSidebarOpen ? 'open' : ''} ${showSidebar ? 'visible' : 'hidden'}`}>
          <h3>CREDENCIAMENTO</h3>
          <ul>
            <h6>AUTORIDADES CERTIFICADORAS</h6>
            <li><a href="/">Atendimento</a></li>
            <li><a href="/ac-pendencia">Pendências</a></li>
            <li><a href="/ac-concluido">Concluídos</a></li>
            <h6>AUTORIDADES DE REGISTRO</h6>
            <li><a href="/ar-atendimento">Atendimento</a></li>
            <li><a href="/ar-pendencia">Pendências</a></li>
            <li><a href="/ar-concluido">Concluídos</a></li>
            <h6>OUTRAS ENTIDADES</h6>
            <li><a href="/outras-atendimento">Atendimento</a></li>
            <li><a href="/outras-pendencia">Pendências</a></li>
            <li><a href="/outras-concluido">Concluídos</a></li>
            <h6>AJUDA</h6>
            <div className="ajuda-section">
              <li><a href="../ajuda/ac">ACs</a></li>
              <li><a href="../ajuda/ar">ARs</a></li>
              <li><a href="../ajuda/outras">Outras Entidades</a></li>
              <img src={logo} alt="logo"/>
            </div>
          </ul>
        </div>
      </div>
  );
}
